import * as React from "react";
import sortBy from "lodash/sortBy";
import ClampLines from "react-clamp-lines";
import { useHistory, useParams } from "react-router-dom";
import { IWorkout } from "../../resources/user/types";
import { parseApiDate } from "../../helpers/date";
import styles from "./workout.module.css";

interface IProps {
  workout: IWorkout;
}

export default function Workout({ workout }: IProps) {
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const onWorkoutClick = (workout: IWorkout) => () =>
    history.push(`/users/${id}/workout/edit/${workout.id}`);

  const date = parseApiDate(workout.date).format("ddd, MMM DD, YYYY");

  return (
    <div onClick={onWorkoutClick(workout)} className={styles.trainingItem}>
      <div className={styles.head}>
        <span className={styles.date}>{date}</span>
        <div className={styles.edit}>
          <div>VIEW</div>
        </div>
      </div>
      {sortBy(workout.exercises || [], "pos").map(exercise => (
        <div key={exercise.id}>
          {(exercise.exerciseSets || []).map(exerciseSet => (
            <div key={exerciseSet.id} className={styles.row}>
              <div className={styles.exercise}>{exercise.title}</div>
              <div className={styles.exerciseValues}>
                <div className={styles.exerciseItem}>{exerciseSet.sets}</div>
                <div className={styles.exerciseItem}>x</div>
                <div className={styles.exerciseItem}>{exerciseSet.reps}</div>
                <div className={styles.exerciseItem}>@</div>
                <div className={styles.exerciseItem}>
                  {`${exerciseSet.weight} lbs`}
                </div>
              </div>
            </div>
          ))}
        </div>
      ))}
      {workout.note && (
        <div>
          <div className={styles.noteTitle}>Notes</div>
          <ClampLines
            text={workout.note}
            id="really-unique-id"
            lines={2}
            ellipsis="..."
            moreText="Tap for More"
            lessText="Tap for Less"
            className={styles.note}
            innerElement="p"
          />
        </div>
      )}
    </div>
  );
}
